import ModerationPage from './ModerationPage';
import moderationPageReducer from './reducer';

export { moderationPageReducer };
export default ModerationPage;
